export default {
    // 用户端生效中的活动查看
    selectMarketingActivityDetailByUser:
        "/gateway/huilianOperation/hoMarketingActivitycs/selectMarketingActivityDetailByUser",
    // 微信生效中的活动查看
    selectMarketingActivityDetailForFree:
        "/gateway/huilianOperation/hoMarketingActivitycs/selectMarketingActivityDetailForFree",
    // 领取优惠券
    receiveMarketingCoupons:
        "/gateway/huilianOperation/hoMarketingActivitycs/receiveMarketingCoupons",
    // 一键领取组件全部优惠券
    receiveMarketingAllCoupons:
        "/gateway/huilianOperation/hoMarketingActivitycs/receiveMarketingAllCoupons",
    // 用户抽奖
    lotteryMarketingPrize:
        "/gateway/huilianOperation/hoMarketingActivitycs/lotteryMarketingPrize",
    // 用户当前可抽奖次数
    userLotteryMarketingNum:
        "/gateway/huilianOperation/hoMarketingActivitycs/userLotteryMarketingNum",
    // 领取任务奖励
    receiveMarketingTaskPrize:
        "/gateway/huilianOperation/hoMarketingActivitycs/receiveMarketingTaskPrize",
    // 用户奖品列表
    userMarketingPrizeList:
        "/gateway/huilianOperation/hoMarketingActivitycs/userMarketingPrizeList",
    // 活动规则
    selectMarketingRule:
        "/gateway/huilianOperation/hoMarketingActivitycs/selectMarketingRule",
    // 用户积分
    userTotalIntegral: "/gateway/huilianOperation/membercs/userTotalIntegral",
    // 数字化营销活动礼包奖励领取
    receiveMarketingPrizes:
        "/gateway/huilianOperation/hoMarketingActivitycs/receiveMarketingPrizes",
    // 数字化营销活动礼包奖励领取状态
    receivedMarketingPrizesFlag:
        "/gateway/huilianOperation/hoMarketingActivitycs/receivedMarketingPrizesFlag",
    messageLogin: "/gateway/huilianCust/logincs/messageLogin", //账号密码登录
    messageCode: "/gateway/manageBedrock/messagecs/messageCode", //获取验证码
    imageCode: "/gateway/manageBedrock/messagecs/createImageCode", //获取图片验证码
    createSlideImage: "/gateway/manageBedrock/messagecs/createSlideImage", // 获取滑动图片
};



// WEBPACK FOOTER //
// ./src/ActivityModule/api.js